import { useEffect, useRef } from 'react';
import FadeIn from './FadeIn'; // Assurez-vous d'utiliser votre composant FadeIn !

export default function Hero() {
  const baseTarget = useRef(null);
  const gradientTarget = useRef(null);

  useEffect(() => {
    const baseText = 'Creative Lab ';
    const gradientText = 'Learning out loud';
    let i = 0;
    let j = 0;
    let timeoutId;

    const typeEffect = () => {
      if (!baseTarget.current || !gradientTarget.current) return;

      if (i < baseText.length) {
        baseTarget.current.textContent += baseText.charAt(i);
        i++;
        timeoutId = setTimeout(typeEffect, 80);
      } else if (j < gradientText.length) {
        gradientTarget.current.textContent += gradientText.charAt(j);
        j++;
        timeoutId = setTimeout(typeEffect, 100);
      }
    };

    // On vide le texte au cas où on revienne sur la page
    if (baseTarget.current) baseTarget.current.textContent = '';
    if (gradientTarget.current) gradientTarget.current.textContent = '';
    
    // Lancement de l'animation
    typeEffect();

    // Nettoyage si on change de page en pleine animation
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <FadeIn className="section full-height" id="home">
      <div className="hero-content">
        <h1 className="hero-title">
          <span ref={baseTarget} id="type-base"></span>
          <span ref={gradientTarget} id="type-gradient"></span>
          <span className="cursor">|</span>
        </h1>
        <p className="hero-desc">
          Product design, identité visuelle et creative coding.
        </p>
      </div>
    </FadeIn>
  );
}